export default __webpack_public_path__ + "static/media/Insider_Trading_Policy_2.53a871c0.pdf";